module.exports = __webpack_public_path__ + "static/media/costume.7f8c1684.jpg";